<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">标题接口管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.title_name" placeholder="请输入接口名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增接口
        </el-button>
      </div>

      <!-- 接口列表 -->
      <el-table :data="titleList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="title_name" label="接口名称" width="180" />
        <el-table-column prop="key_preview" label="密钥预览" width="180">
          <template #default="{ row }">
            <span class="key-preview">{{ row.key_preview }}******</span>
          </template>
        </el-table-column>
        <el-table-column prop="title_url" label="接口地址" min-width="200" show-overflow-tooltip />
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchTitleList" @current-change="fetchTitleList" />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">

      <!-- 新增：5118接口申请提示 -->
      <div class="api-tip-box">
        <el-alert title="还没有5118接口密钥？" type="info" :closable="false" show-icon center>
          <template #default>
            <a href="https://www.5118.com/apistore/detail/8cf3d6ed-2b12-ed11-8da8-e43d1a103141" target="_blank"
              class="api-link">
              立即申请5118接口（新用户专享优惠）
            </a>
          </template>
        </el-alert>
      </div>

      <el-form ref="titleForm" :model="titleForm" label-width="120px" :rules="formRules">
        <el-form-item label="接口名称" prop="title_name">
          <el-input v-model="titleForm.title_name" placeholder="请输入接口名称" size="large" />
        </el-form-item>

        <el-form-item label="接口地址" prop="title_url">
          <el-input v-model="titleForm.title_url" placeholder="请输入标题接口地址" size="large" />
        </el-form-item>

        <el-form-item label="接口密钥" prop="title_key">
          <el-input v-model="titleForm.title_key" placeholder="请输入接口密钥" size="large" show-password />
        </el-form-item>

        <!-- 新增：测试连通性按钮 -->
        <el-form-item label="测试连通性">
          <el-button type="primary" size="large" @click="testConnection" :loading="testingConnection"
            :disabled="!titleForm.title_url || !titleForm.title_key">
            <el-icon>
              <Connection />
            </el-icon>
            测试连通性
          </el-button>
          <span class="test-result" :class="{ 'success': testResult === 'success', 'error': testResult === 'error' }">
            {{ testResult === 'success' ? '✓ 测试通过' : testResult === 'error' ? '✗ 测试失败' : '' }}
          </span>
        </el-form-item>


        <el-form-item label="备注信息">
          <el-input v-model="titleForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTitleForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete, Connection
} from '@element-plus/icons-vue'

export default {
  name: 'SystemTitleApi',
  components: { Search, Plus, Edit, Delete, Connection },
  data() {
    // URL验证函数
    const validateUrl = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入接口地址'));
      } else if (!/^https?:\/\/.+/.test(value)) {
        callback(new Error('请输入有效的URL地址'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增接口',
      isEditMode: false,
      testingConnection: false,
      testResult: '',
      searchForm: {
        title_name: ''
      },
      titleForm: {
        id: null,
        title_name: '',
        title_url: 'http://apis.5118.com/keyword/word/v2',
        title_key: '',
        notes: ''
      },
      formRules: {
        title_name: [
          { required: true, message: '请输入接口名称', trigger: 'blur' }
        ],
        title_url: [
          { required: true, validator: validateUrl, trigger: 'blur' }
        ],
        title_key: [
          { required: true, message: '请输入接口密钥', trigger: 'blur' }
        ]
      },
      titleList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchTitleList();
  },
  methods: {
    // 获取接口列表
    async fetchTitleList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.title_name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        // 如果有搜索条件，加入搜索参数
        if (this.searchForm.title_name) {
          params.title_name = this.searchForm.title_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/TitleModelKeyController.php`,
          params
        );

        if (data.data) {
          this.titleList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取接口列表失败');
        console.error('获取接口列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchTitleList();
    },

    // 测试接口连通性
    async testConnection() {
      if (!this.titleForm.title_url || !this.titleForm.title_key) {
        this.$message.warning('请先填写接口地址和密钥');
        return;
      }

      this.testingConnection = true;
      this.testResult = '';

      try {
        // 调用我们自己的 PHP 测试接口
        const response = await axios.post(
          'https://gzh.aijzdi.com/shop/api/test_5118_api.php', // 确保路径正确
          {
            title_url: this.titleForm.title_url,
            title_key: this.titleForm.title_key
          }
        );

        if (response.data.success) {
          this.testResult = 'success';
          this.$message.success('接口连接测试成功！');
        } else {
          this.testResult = 'error';
          this.$message.error(`测试失败: ${response.data.message}`);
        }
      } catch (error) {
        this.testResult = 'error';
        let errorMessage = '连接测试失败';

        if (error.response) {
          errorMessage += ` (状态码: ${error.response.status})`;
          if (error.response.data?.message) {
            errorMessage += `: ${error.response.data.message}`;
          }
        } else if (error.request) {
          errorMessage += ': 服务器无响应';
        } else {
          errorMessage += `: ${error.message}`;
        }

        this.$message.error(errorMessage);
        console.error('API测试错误详情:', error);
      } finally {
        this.testingConnection = false;
      }
    },

    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增接口';
      this.isEditMode = false;
      this.titleForm = {
        id: null,
        title_name: '',
        title_url: 'http://apis.5118.com/keyword/word/v2', // 设置默认地址
        title_key: '',
        notes: ''
      };
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑接口';
      this.isEditMode = true;
      this.titleForm = {
        id: row.id,
        title_name: row.title_name,
        title_url: row.title_url,
        title_key: row.title_key, // 注意：实际应用中可能需要从后端获取完整密钥
        notes: row.notes
      };
      this.dialogVisible = true;
    },

    // 提交表单（新增/编辑）
    submitTitleForm() {
      this.$refs.titleForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.titleForm,
              store_id: this.userInfo.id
            };

            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/TitleModelKeyController.php`,
              {
                action,
                ...payload
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchTitleList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除接口
    async handleDelete(id) {
      this.$confirm('确定要删除该接口配置吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/TitleModelKeyController.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchTitleList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 0px;
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}

/* 新增特定样式 */
.key-preview {
  font-family: monospace;
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
}

/* 表单验证提示样式 */
:deep(.el-form-item__error) {
  font-size: 12px;
  padding-top: 4px;
}

/* 新增测试结果样式 */
.test-result {
  margin-left: 15px;
  font-size: 14px;

  &.success {
    color: #67c23a;
  }

  &.error {
    color: #f56c6c;
  }
}

/* 新增的5118提示样式 */
.api-tip-box {
  margin-bottom: 20px;

  .api-link {
    display: inline-block;
    margin-left: 8px;
    font-weight: 600;
    color: #1890ff;
    text-decoration: none;
    transition: all 0.3s;
    padding: 4px 8px;
    border-radius: 4px;

    &:hover {
      color: #096dd9;
      background-color: rgba(24, 144, 255, 0.1);
      text-decoration: underline;
    }

    &::after {
      content: "↗";
      margin-left: 5px;
      font-size: 0.9em;
    }
  }
}
</style>